import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Typography from '@mui/material/Typography'
import { Upload as UploadIcon } from '@vedmarket/ui-kit'

import Link from '@mui/material/Link'
import {formatCopy} from 'utils/typography'

import { COLORS, DOCUMENT_IMPORT_ENABLED } from 'config/constants'
import { readOnlyButtonEndIcon } from 'components/common/read-only-action-icon'
import { useCalculationReadOnly } from 'components/cabinet/calculator/calculation-read-only'

import DocumentImportModal from './document-import-modal'

import './document-import-trigger.scss'

const DocumentImportTrigger = ({ onApplied, isInline }: CalculatorDocumentImportTriggerProps) => {
  const { t } = useTranslation()
  const readOnly = useCalculationReadOnly()
  const [ isOpen, setIsOpen ] = useState(false)
  const disabled = readOnly || !DOCUMENT_IMPORT_ENABLED

  let buttonTitle: string | undefined
  if (readOnly) {
    buttonTitle = t('calc__message__lockedByApplication')
  } else if (!DOCUMENT_IMPORT_ENABLED) {
    buttonTitle = t('calc__text__documentImport__temporarilyDisabled')
  }

  const uploadAction = (
    <Link
      component='button'
      type='button'
      variant='body2'
      underline={disabled ? 'none' : 'hover'}
      className='document-import-trigger-inline'
      disabled={disabled}
      onClick={() => setIsOpen(true)}
      title={buttonTitle}
      sx={{
        color: disabled ? COLORS.LIGHT_TEXT_DISABLED : COLORS.BLUE,
        '&:disabled': {color: COLORS.LIGHT_TEXT_DISABLED},
      }}
    >
      <UploadIcon />
      <Typography component='span' variant='inherit'>
        {formatCopy(t('calc__text__documentImport__trigger'))}
      </Typography>
      {readOnlyButtonEndIcon(readOnly)}
    </Link>
  )

  return (
    <>
      {isInline ? uploadAction : <div className='document-import-trigger'>
        {uploadAction}
      </div>}
      {isOpen && (
        <DocumentImportModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onApplied={onApplied}
        />
      )}
    </>
  )
}

export default DocumentImportTrigger
